import * as pdfjsLib from './pdf.min.mjs';

pdfjsLib.GlobalWorkerOptions.workerSrc = './pdf.worker.min.mjs';

function renderPage(pdf, pageNumber) {
  pdf.getPage(pageNumber).then(function (page) {
    var canvas = document.getElementById('pdf-canvas');
    var context = canvas.getContext('2d');

    var baseViewport = page.getViewport({ scale: 1 });

    var rect = canvas.getBoundingClientRect();
    var availableCssWidth =
      rect.width || canvas.clientWidth || baseViewport.width;
    var availableCssHeight =
      rect.height || canvas.clientHeight || baseViewport.height;

    var scaleW = availableCssWidth / baseViewport.width;
    var scaleH = availableCssHeight / baseViewport.height;
    var scale = Math.min(scaleW || 1, scaleH || scaleW || 1);

    var viewport = page.getViewport({ scale: scale });

    var dpr = window.devicePixelRatio || 1;

    canvas.width = Math.floor(viewport.width * dpr);
    canvas.height = Math.floor(viewport.height * dpr);
    canvas.style.width = Math.floor(viewport.width) + 'px';
    canvas.style.height = Math.floor(viewport.height) + 'px';

    context.setTransform(dpr, 0, 0, dpr, 0, 0);

    var renderContext = {
      canvasContext: context,
      viewport: viewport,
    };
    page.render(renderContext);
  });
}

window.viewPdf = function (pdfUrl) {
  return new Promise((resolve, reject) => {
    pdfjsLib.getDocument(pdfUrl).promise.then(
      function (pdf) {
        renderPage(pdf, 1);
        return resolve(pdf);
      },
      function (error) {
        return reject(error);
      },
    );
  });
};

function setPageIndicator(pageNumber) {
  const currentPageElement = document.querySelector(
    '.brochure-viewer__current-page',
  );

  if (!currentPageElement) return;

  currentPageElement.textContent = pageNumber;
}

function setButtonStates(pdf, pageNumber) {
  const prevButton = document.querySelector('.brochure-viewer__previous-page');

  if (!prevButton) return;

  prevButton.disabled = pageNumber === 1;

  const nextButton = document.querySelector('.brochure-viewer__next-page');

  if (!nextButton) return;

  nextButton.disabled = pageNumber === pdf.numPages;
}

document.addEventListener('DOMContentLoaded', function () {
  let pdf = null;
  window.currentPage = 1;
  const downloadBrochureCta = document.querySelector('.download-brochure-cta');

  const totalPagesElement = document.querySelector(
    '.brochure-viewer__total-pages',
  );

  if (!totalPagesElement) return;

  if (!downloadBrochureCta) return;

  const modal = document.querySelector('.brochure-viewer__modal');

  if (!modal) return;

  const pdfUrl = modal.dataset.pdfUrl;

  downloadBrochureCta.addEventListener('click', function () {
    window.viewPdf(pdfUrl).then(function (_pdf) {
      pdf = _pdf;
      totalPagesElement.textContent = pdf.numPages;
      window.currentPage = 1;
      setPageIndicator(1);
      setButtonStates(pdf, 1);

      document.documentElement.classList.add('overflow-y-hidden');
    });
  });

  const prevButton = document.querySelector('.brochure-viewer__previous-page');

  if (!prevButton) return;

  prevButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (currentPage > 1) {
      currentPage--;
      renderPage(pdf, currentPage);
      setPageIndicator(currentPage);
      setButtonStates(pdf, currentPage);
    }
  });

  const nextButton = document.querySelector('.brochure-viewer__next-page');

  if (!nextButton) return;

  nextButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (currentPage < pdf.numPages) {
      currentPage++;
      renderPage(pdf, currentPage);
      setPageIndicator(currentPage);
      setButtonStates(pdf, currentPage);
    }
  });

  const closePopup = () => {
    modal.hidePopover();
    document.documentElement.classList.remove('overflow-y-hidden');
  };

  const popupDownloadButton = document.querySelector(
    '.brochure-viewer__download',
  );

  if (!popupDownloadButton) return;

  popupDownloadButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    closePopup();

    const subscriptionElem = document.querySelector(
      '.brochure-newsletter-subscription',
    );

    if (!subscriptionElem) return;

    const rect = subscriptionElem.getBoundingClientRect();
    const yOffset = window.pageYOffset + rect.top - 75;
    window.scrollTo({
      top: yOffset,
      behavior: 'smooth',
    });
  });

  const popupCloseButton = document.querySelector('.brochure-viewer__close');

  if (!popupCloseButton) return;

  popupCloseButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    closePopup();
  });

  // Handle window resize to resize the PDF canvas
  let resizeTimeout;
  window.addEventListener('resize', function () {
    // Debounce resize events to avoid excessive re-renders
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      // Only re-render if PDF is loaded, modal is open, and current page is set
      if (pdf && currentPage > 0 && modal.matches(':popover-open')) {
        const canvas = document.getElementById('pdf-canvas');
        if (canvas) {
          // Reset inline styles to let CSS constraints take effect
          canvas.style.width = '';
          canvas.style.height = '';
          // Use requestAnimationFrame to ensure browser has finished layout recalculation
          requestAnimationFrame(function () {
            // Force a reflow to ensure dimensions are recalculated
            void canvas.offsetWidth;
            // Now re-render with updated dimensions
            renderPage(pdf, currentPage);
          });
        }
      }
    }, 150);
  });
});
